import { useMemo } from "react";

import { type MutationFunction, useMutation } from "@apollo/client";

import { type OnboardLensToLensCloudResponse } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { onboardLensToLensCloud } from "../api/mutations/onboardLensToLensCloud";
import {
    type OnboardLensToLensCloudMutation,
    type OnboardLensToLensCloudMutationVariables,
} from "../api/mutations/onboardLensToLensCloud.gql-generated";
import { lensCloudApp } from "../api/queries/lensCloudApp";

interface UseOnboardLensToLensCloudParams {
    lensId: string;
}

export const useOnboardLensToLensCloud = ({
    lensId,
}: UseOnboardLensToLensCloudParams): ApolloResult<
    OnboardLensToLensCloudResponse & {
        onboardLens: MutationFunction<OnboardLensToLensCloudMutation, OnboardLensToLensCloudMutationVariables>;
    }
> => {
    const [onboardLens, { data, loading, error }] = useMutation<
        OnboardLensToLensCloudMutation,
        OnboardLensToLensCloudMutationVariables
    >(onboardLensToLensCloud, {
        variables: {
            lensId,
        },
        awaitRefetchQueries: true,
        refetchQueries: [lensCloudApp],
    });

    return useMemo(() => {
        return {
            loading,
            error,
            appId: data?.onboardLensToLensCloud.appId ?? "",
            onboardLens,
        };
    }, [loading, error, data, onboardLens]);
};
